/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DailyReminderSettingsDto } from './DailyReminderSettingsDto';

export type ManageNotificationsDto = {
    /**
     * Platform for the provided FCM token
     */
    platform: ManageNotificationsDto.platform;
    /**
     * FCM token for this device (required when enabling, optional when disabling: null to only flip the flag or provide a token to unregister)
     */
    fcmToken: string | null;
    /**
     * Unique device identifier
     */
    deviceId?: string;
    enabled: boolean;
    dailyReminder?: DailyReminderSettingsDto;
};

export namespace ManageNotificationsDto {

    /**
     * Platform for the provided FCM token
     */
    export enum platform {
        ANDROID = 'android',
        IOS = 'ios',
    }


}

